import { SelectMui } from 'src/components/SelectMui'
import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const CustomSelect = styled(SelectMui)`
    width: 13.6rem;    
    margin: 0 !important;
    height: 2.5rem !important;
`
export const CustomButton = styled(ButtonMui)`
    width: 100%;    
    height: 2.5rem !important;
    margin: 0 !important;
`
export const CustomTextField = styled(TextFieldMui)`
    width: 13.6rem;    
    height: 2.5rem !important;
    margin: 0 !important;
`
